import { forwardRef, type SVGProps } from 'react';

export const Columns = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ref={ref} {...props}>
    <g>
      <mask id="b" style={{ maskType: 'alpha' }} width="26" height="21" x="0" y="2" maskUnits="userSpaceOnUse">
        <path fill="#C4C4C4" d="M.5 2.5h25v5H18L4.5 21v1.5h-4v-20z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="currentColor"
          d="M4 21h15.893c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm0-2v-5h4v5H4zM14 7v5h-4V7h4zM8 7v5H4V7h4zm2 12v-5h4v5h-4zm6 0v-5h3.894v5H16zm3.893-7H16V7h3.893v5z"
        />
      </g>
      <path
        fill="currentColor"
        d="m16.462 12.008-5.228 5.227a.375.375 0 0 0-.096.166l-1.125 4.125a.375.375 0 0 0 .46.46l4.126-1.124a.375.375 0 0 0 .166-.096l5.227-5.228-3.53-3.53zm5.208.261-1.94-1.94a1.125 1.125 0 0 0-1.59 0l-.883.883 3.53 3.53.883-.882a1.125 1.125 0 0 0 0-1.591z"
      />
    </g>
  </svg>
));
